import { CalendarDays, Home, Lightbulb } from "lucide-react";

interface NavItem {
  label: string;
  icon: typeof Home;
  href: string;
}

// Shared between the desktop Sidebar and the mobile BottomTabBar so the two
// breakpoints never drift out of sync. PTO Entries / Activity Suggestions
// routes land in WI-002 — the routes referenced here exist by then.
export const NAV_ITEMS: NavItem[] = [
  { label: "Home", icon: Home, href: "/dashboard" },
  { label: "Entries", icon: CalendarDays, href: "/dashboard/entries" },
  { label: "Suggestions", icon: Lightbulb, href: "/dashboard/suggestions" },
];
